import React from 'react';

import { MarketingPageLayoutLayout } from './MarketingPageLayout.types';

export type MarketingPageLayoutContextValue = {
  layout: MarketingPageLayoutLayout;
};

export const MarketingPageLayoutContext =
  React.createContext<MarketingPageLayoutContextValue>({
    layout: 'imageSideEnd',
  });
